import React, { createElement, Fragment } from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import { getMediaPath } from '../../../../app/functions';
import './index.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TeamSection = () => {
    const insurancePage = useSelector((store) => store.insurancePage);

    const teamData = [...insurancePage?.team] || [];

    teamData.sort(
        (a, b) => a['order_num'] - b['order_num']
    );

    return (
        <section className="team-section">
            <h2 className="team-title">
                {insurancePage?.general?.team_title}
            </h2>

            <Slider autoplay centerMode infinite rtl variableWidth>
                {teamData.map((teamItemData) => (
                    <div key={teamItemData?.id}>
                        <TeamItem data={teamItemData} />
                    </div>
                ))}
            </Slider>
        </section>
    );
};

const TeamItem = ({ data }) => {
    const itemElement = data?.link_address ? 'a' : Fragment;

    const itemProps = data?.link_address ? {
        href: data?.link_address,
        target: '_blank',
    } : {};

    const itemContent = (
        <img
            src={getMediaPath(data?.logo_path)}
            alt={data?.name}
            className="team-logo"
        />
    );

    return createElement(itemElement, itemProps, itemContent);
};

export default TeamSection;
